import { Paging } from 'src/models/paging.types';

export default (paging: Paging): number => {
    if (paging?.lastPage?.page) {
        // lastPage is not present when there is not much pages
        return paging.lastPage.page + 1;
    }
    return Math.max(...paging.pages.map(({ text }) => Number(text)).filter((e) => !isNaN(e)));
};
